export const colors = {
  black: '#000000',
  neutral45: '#6E6E6E',
  neutral75: '#BBBBBB',
  neutral80: '#CCCCCC',
  neutral85: '#d6d6d6',
  neutral90: '#e6e6e6',
  neutral95: '#F4F4F4',
  green: '#008A27',
} as const;
